module.exports = __webpack_public_path__ + "static/media/reservation-complete.6ca4cc46.svg";